import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { exportTransactionsSuccess, exportTransactionsFailure } from '../actions';
import { saveDownloadIds } from 'redux/direct-download/actions';
import transactionHistoryTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';
import { getOrgName } from 'utils/helpers';


const { API_BASE_URL } = urls || {};

function* exportTransactionsData({ payload }) {
  const { data, cb } = payload;
  const url = `${API_BASE_URL}/payments/export`;

  const response = yield request({
    method: 'post',
    data,
    url,
  });

  if (response.success) {
    yield put(exportTransactionsSuccess());
    yield put(saveDownloadIds({id : response.raw.id, org: getOrgName()}));
    cb();
  } else {
    yield put(
      exportTransactionsFailure(
        'An error occured. Please reload the page to try again.'
      )
    );
    networkErrorHandler(response?.statusCode, response.message || 'An error occured. Please reload the page to try again.');
  }
}

export function* onExportTransactionData() {
  yield takeLatest(
    transactionHistoryTypes.EXPORT_TRANSACTION_START,
    exportTransactionsData
  );
}
